import { LAVENDER_STEEL } from 'utils/theme';
import { ReactNode } from 'react';

export interface BaseIconProps {
  width?: number;
  height?: number;
  stroke?: string;
  fill?: string;
  className?: string;
  rotation?: number;
  'data-testid'?: string;
}

export const DEFAULT_ICON_SIZE = 20;
export const DEFAULT_STROKE = LAVENDER_STEEL;

export interface IconProps extends BaseIconProps {
  children: ReactNode;
  viewBox?: string;
}

export const BaseIcon = ({
  width = DEFAULT_ICON_SIZE,
  height = DEFAULT_ICON_SIZE,
  stroke = DEFAULT_STROKE,
  fill = 'none',
  className,
  children,
  viewBox = '0 0 24 24',
  rotation = 0,
  'data-testid': dataTestId,
}: IconProps) => {
  const style = rotation ? { transform: `rotate(${rotation}deg)` } : undefined;

  return (
    <svg
      width={width}
      height={height}
      stroke={stroke}
      fill={fill}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      data-testid={dataTestId}
    >
      {children}
    </svg>
  );
};
